import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Wiadomości e-mail',
  labels: {
    view_full_message: 'Zobacz pełną wiadomość',
    status: 'Status:',
    on: 'Wł.',
    off: 'Wył.',
  },
  tiles: {
    sends_count: 'Wysłane wiadomości',
    delivery_rate: 'Wskaźnik dostarczenia',
    delivered_suffix: 'dostarczono',
    open_rate: 'Wskaźnik otwarć',
    opened_suffix: 'otwarto',
    click_rate: 'Wskaźnik kliknięć',
    clicked_suffix: 'kliknięto',
    spam_report_rate: 'Wskaźnik zgłoszeń spam',
    spam_reports_suffix: 'zgłoszenia',
    unsubscribe_rate: 'Wskaźnik rezygnacji',
    unsubscribes_suffix: 'rezygnacje',
  },
  toasts: {
    failed_to_update_status: 'Nie udało się zaktualizować statusu',
    failed_to_load_data: 'Nie udało się załadować danych',
  },

  preview_modal: {
    title: 'Podgląd szablonu',
    labels: {
      subject: 'Temat:',
      close: 'Zamknij',
    },
    toasts: {
      failed_to_load_data: 'Nie udało się załadować podglądu',
    },
    template_data: {
      recipient_name: '&lt;Imię&gt;',
    },
  },
};
